import { ACCENT, PAPER, illustrationA11y, lineStyle } from './static-art';

export function CauseCardIllustration(props: { className?: string; label?: string; ink?: string; paper?: string }) {
	const line = lineStyle(props.ink);
	return (
		<svg
			width="212"
			height="98"
			viewBox="23 95 212 98"
			fill="none"
			className={props.className}
			{...illustrationA11y(props.label)}
		>
			<g opacity="0.5">
				<rect x="55.75" y="128" width="178" height="64" rx="4" fill={props.paper ?? PAPER} />
				<rect x="55.75" y="128" width="178" height="64" rx="4" {...line} />
				<path
					d="M133.837 136H66.6627C65.0541 136 63.75 137.193 63.75 138.665V181.335C63.75 182.807 65.0541 184 66.6627 184H133.837C135.446 184 136.75 182.807 136.75 181.335V138.665C136.75 137.193 135.446 136 133.837 136Z"
					fill={ACCENT}
				/>
				<path
					d="M113.653 147.664C107.846 143.35 101.971 148.541 99.9394 150.68C99.5224 151.119 98.8217 151.142 98.3723 150.735C92.4314 145.336 87.4551 146.736 84.9844 148.08C83.726 148.766 82.7751 149.875 82.2722 151.2C80.1923 156.686 84.6882 163.152 89.357 167.985L92.2248 170.883C94.82 173.15 97.4712 175.045 98.5553 175.799C98.9374 176.065 99.449 176.067 99.8348 175.805C113.713 166.372 121.435 153.443 113.652 147.662L113.653 147.664Z"
					fill="#FFD8BB"
				/>
				<path d="M147.75 152H209.75" {...line} />
				<path d="M147.75 160H197.75" {...line} />
				<path d="M147.75 168H184.75" {...line} />
			</g>
			<rect x="39.75" y="112" width="178" height="64" rx="4" fill={props.paper ?? PAPER} />
			<rect x="39.75" y="112" width="178" height="64" rx="4" {...line} />
			<path
				d="M117.837 120H50.6627C49.0541 120 47.75 121.193 47.75 122.665V165.335C47.75 166.807 49.0541 168 50.6627 168H117.837C119.446 168 120.75 166.807 120.75 165.335V122.665C120.75 121.193 119.446 120 117.837 120Z"
				fill={ACCENT}
			/>
			<path
				d="M97.6534 131.664C91.8457 127.35 85.9707 132.541 83.9394 134.68C83.5224 135.119 82.8217 135.142 82.3723 134.735C76.4314 129.336 71.4551 130.736 68.9844 132.08C67.726 132.766 66.7751 133.875 66.2722 135.2C64.1923 140.686 68.6882 147.152 73.357 151.985L76.2248 154.883C78.82 157.15 81.4712 159.045 82.5553 159.799C82.9374 160.065 83.449 160.067 83.8348 159.805C97.7132 150.372 105.435 137.443 97.6522 131.662L97.6534 131.664Z"
				fill="#FFD8BB"
			/>
			<path d="M131.75 136H193.75" {...line} />
			<path d="M131.75 144H181.75" {...line} />
			<path d="M131.75 152H168.75" {...line} />
			<rect x="23.75" y="96" width="178" height="64" rx="4" fill={props.paper ?? PAPER} />
			<rect x="23.75" y="96" width="178" height="64" rx="4" {...line} />
			<path
				d="M101.837 104H34.6627C33.0541 104 31.75 105.193 31.75 106.665V149.335C31.75 150.807 33.0541 152 34.6627 152H101.837C103.446 152 104.75 150.807 104.75 149.335V106.665C104.75 105.193 103.446 104 101.837 104Z"
				fill={ACCENT}
			/>
			<path
				d="M81.6534 115.664C75.8457 111.35 69.9707 116.541 67.9394 118.68C67.5224 119.119 66.8217 119.142 66.3723 118.735C60.4314 113.336 55.4551 114.736 52.9844 116.08C51.726 116.766 50.7751 117.875 50.2722 119.2C48.1923 124.686 52.6882 131.152 57.357 135.985L60.2248 138.883C62.82 141.15 65.4712 143.045 66.5553 143.799C66.9374 144.065 67.449 144.067 67.8348 143.805C81.7132 134.372 89.4353 121.443 81.6522 115.662L81.6534 115.664Z"
				fill="#FFD8BB"
			/>
			<path d="M115.75 120H177.75" {...line} />
			<path d="M115.75 128H165.75" {...line} />
			<path d="M115.75 136H152.75" {...line} />
		</svg>
	);
}
